import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { ServiceProfileState } from "./model";

let state: ServiceProfileState = {
  serviceProfiles: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<ServiceProfileState, RootStateType>;
